import { ReactComponent as CloseIcon } from '@paradigm/icons/src/mailru/actions/close_big.svg';
import classNames from 'clsx';
import React, { memo, ReactElement, RefObject, useCallback, useEffect } from 'react';
import { Tooltip } from 'reactApp/ui/Tooltip/Tooltip';
import { tooltipPlacements } from 'reactApp/ui/Tooltip/Tooltip.constants';
import { sendGa } from 'reactApp/utils/ga';

import styles from './PromoProTooltip.css';

export interface IProps {
    target?: RefObject<HTMLElement>;
    onClose: () => void;
    gaLabel?: string;
    tariffsType?: string;
    bottom?: boolean;
}

export const PromoProTooltip = memo(({ target, onClose, gaLabel, tariffsType = '', bottom = false }: IProps): ReactElement | null => {
    const isPaid = tariffsType === 'paid';

    const sendGaTooltip = useCallback(
        (action: string) => {
            sendGa(gaLabel ?? 'promo-pro-tooltip', action);
            sendGa(gaLabel ?? 'promo-pro-tooltip', action, tariffsType);
        },
        [gaLabel, tariffsType]
    );

    const handleClose = useCallback(
        (e) => {
            e?.preventDefault();
            e?.stopPropagation();

            sendGaTooltip('close');
            onClose();
        },
        [onClose]
    );

    const handleClick = useCallback((e) => {
        e?.stopPropagation();
        sendGaTooltip('click');
    }, []);

    useEffect(() => {
        sendGaTooltip('show');
    }, []);

    if (!(target && target.current)) {
        return null;
    }

    const br = bottom ? null : <br />;

    return (
        <Tooltip
            pinned
            forceAutoPosition={false}
            smartPlacement={false}
            placement={bottom ? tooltipPlacements.BOTTOM : tooltipPlacements.RIGHT}
            target={target}
            theme={bottom ? 'octavius' : 'withinDialog'}
            onClose={handleClose}
            radius={16}
            enableTransparentDimmer
            offset={{ x: bottom ? 0 : 4 }}
            arrowColor={isPaid || bottom ? '#fff' : '#19191A'}
            minWidth={!bottom}
        >
            <div
                className={classNames({
                    [styles.root]: true,
                    [styles.root_light]: isPaid || bottom,
                    [styles.root_bottom]: bottom,
                })}
                onClick={handleClick}
            >
                <div className={styles.close} onClick={handleClose}>
                    <CloseIcon width={12} height={12} />
                </div>
                Автоудаление папок доступно только
                {br} в {isPaid ? 'платных' : 'PRO'} тарифах.{' '}
                <a
                    className={classNames({ [styles.link]: true, [styles.button]: bottom })}
                    href={
                        isPaid
                            ? '/subscriptions?utm_source=cloud_folder&utm_medium=referral&utm_campaign=autodelete_subs#year'
                            : '/subscriptions?utm_source=cloud_folder&utm_medium=referral&utm_campaign=autodelete_pro#pro'
                    }
                    target="_blank"
                    rel="noreferrer"
                >
                    {bottom ? 'Попробовать' : 'Попробуйте!'}
                </a>
            </div>
        </Tooltip>
    );
});

PromoProTooltip.displayName = 'PromoProTooltip';
